module.exports = __webpack_public_path__ + "img/Switch-sort-asc.d0ce4c94.svg";